import React from "react";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import Button from "./Button";
import Button1xbet from "./Button1xbet";

function ButtonIndex(props) {
  const { is1xbet } = useMerchantTheme();
  return is1xbet ? <Button1xbet {...props} /> : <Button {...props} />;
}

export default ButtonIndex;
